'use client';

import { useMediaQuery, useTheme } from '@mui/material';

import { ProtectionsComparisonDesktop } from './ProtectionsComparisonDesktop';
import { ProtectionsComparisonMobile } from './ProtectionsComparisonMobile';
import { ProtectionsComparisonProps } from './types';

export const ProtectionsComparisonDialog = ({
  styleParts = {},
  bundles,
  onClose,
  onBundleSelected,
}: ProtectionsComparisonProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (isMobile) {
    return (
      <ProtectionsComparisonMobile
        styleParts={styleParts.mobile}
        bundles={bundles}
        onClose={onClose}
        onBundleSelected={onBundleSelected}
      />
    );
  }

  return (
    <ProtectionsComparisonDesktop
      styleParts={styleParts.desktop}
      bundles={bundles}
      onClose={onClose}
      onBundleSelected={onBundleSelected}
    />
  );
};
